<ng-container
  *ngIf="{
    loading: loading$ | async,
    activeAddressId: activeAddressId$ | async,
    receiptType: receiptType$ | async,
    availableOptions: availableOptions$ | async,
    address: address$ | async,
  } as observables"
>
  <ng-container *ngIf="!!observables.activeAddressId && observables.receiptType === 'delivery'">
    <ng-container *ngIf="!observables.loading; else skeleton">
      <div *ngIf="(observables?.availableOptions | keyvalue)?.length > 0" class="block options">
        <h2>Дополнительные услуги</h2>
        <div [formGroup]="form">
          <div
            *ngIf="observables.availableOptions.unloading || observables.availableOptions.lifting"
            class="option option-nothing"
          >
            <sd-radio formControlName="option" value="noOption" name="option">Без услуг</sd-radio>
          </div>

          <div *ngIf="observables.availableOptions.unloading" class="option option-unloading">
            <sd-radio formControlName="option" value="unloading" name="option">Выгрузка из машины</sd-radio>
            <span class="price">
              + {{ observables.availableOptions.unloading.price }} ₽
              <span
                class="custom-tooltip-price"
                [ngbTooltip]="tooltipUnloadingContent"
                tooltipClass="custom-tooltip"
                triggers="click:blur"
              >
                <cx-icon class="icon-info" [type]="iconType.EXCLAMATION_POINT"></cx-icon>
              </span>
            </span>
          </div>

          <div
            *ngIf="observables.availableOptions.lifting"
            class="option option-lifting"
            [ngClass]="{ disabled: observables.address?.floor === undefined }"
          >
            <sd-radio
              formControlName="option"
              value="lifting"
              [disabled]="observables.address?.floor === undefined"
              name="option"
            >
              <ng-container>Выгрузка и подъём на этаж</ng-container>
            </sd-radio>
            <ng-container *ngIf="observables.address?.floor !== undefined">
              <span class="price" *ngIf="!observables.loading; else skeletonLifting">
                + {{ observables.availableOptions.lifting.price }} ₽
                <span
                  class="custom-tooltip-price"
                  [ngbTooltip]="tooltipPriceProofContent"
                  triggers="click:blur"
                  tooltipClass="custom-tooltip"
                >
                  <cx-icon class="icon-info" [type]="iconType.EXCLAMATION_POINT"></cx-icon>
                </span>
              </span>
            </ng-container>
            <ng-template #skeletonLifting>
              <div class="skelet lifting"></div>
            </ng-template>
          </div>
        </div>
        <ng-container
          *ngIf="observables.address && observables.address.floor === undefined && observables.availableOptions.lifting"
        >
          <div role="alert" class="alert alert-warning">
            <cx-icon class="icon-info" [type]="iconType.EXCLAMATION_POINT"></cx-icon>
            <span class="alert-title">
              В
              <span class="link" (click)="editAddress()">адресе доставки</span>
              не указан этаж
            </span>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </ng-container>
</ng-container>

<ng-container *ngIf="popupIsOpened$ | async">
  <div class="popup">
    <button class="btn-close" (click)="closePopup()" aria-label="Close" tabindex="-1"></button>
    <ng-container *ngTemplateOutlet="notificationContent"></ng-container>
    <button class="btn btn-primary btn-block btn-confirm" (click)="closePopup()">Понятно</button>
  </div>
</ng-container>

<ng-template #notificationContent>
  <b>Как это работает?</b>
  <br />
  <p>Мы оставим ваш заказ у двери, если:</p>
  <ul>
    <li>заказ оплачен на сайте</li>
    <li>выбрана услуга “Выгрузка и подъём на этаж”</li>
    <li>указан полный адрес доставки</li>
  </ul>
</ng-template>

<ng-template #skeleton>
  <div class="block options">
    <h2>Дополнительные услуги</h2>
    <div class="skelet option"></div>
    <div class="skelet option"></div>
    <div class="skelet option"></div>
    <div class="skelet option"></div>
  </div>
</ng-template>

<ng-template #tooltipPriceProofContent>
  <ul>
    <li>{{ priceProofText$ | async }}</li>
    <li>Бесплатно переносим к месту выгрузки - до 30 метров</li>
  </ul>
</ng-template>

<ng-template #tooltipUnloadingContent>
  <p>Стоимость включает в себя только выгрузку заказа рядом с машиной.</p>
</ng-template>
